import React from 'react';
import { Form } from 'react-bootstrap';
import '../App.css';

function PromptPreview({ preview }) {
	return (
		<div className="admin-preview-section">
			<h6 className="admin-form-section-title">Rendered Prompt Preview</h6>
			<Form.Control
				as="textarea"
				className="admin-preview-textarea"
				readOnly={true}
				value={preview}
				rows={16}
			/>
		</div>
	);
}

export default PromptPreview;
